module.exports = __webpack_public_path__ + "img/padel-pala-pelotas.719431fe.jpg";